import React, { Component } from "react";
import { connect } from "react-redux";
import ErrorAction from "../../../../Redux/ErrorRedux";
import Container from "../../../../modules/commons/Container";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { getTableConfig } from "./config";
import { mapToObjectDDL, removeNullFields } from "../../../common/mapper";
import { fetchDataAsync, getUserAccess } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus, INITIAL_PAGINATION } from "../../../common/Constants";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import { saveAs } from "file-saver";
import InventoryPartDetail from "./inventoryPartDetail";
import InventoryPartDownloadModal from "./inventoryPartDownloadModal";
import InventoryPartFilter from "./inventoryPartFilter";
import InventoryPartStock from "./inventoryPartStock";
class InventoryPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
      kodeCabang: null,
      loading: false,
      pagination: INITIAL_PAGINATION,
      skipNextFetch: false,
      submittedFilter: null,
      detailVisibility: false,
      selectedData: null,
      printVisible: false,
      filterVisible: false,
      stockVisible: false,
      keyword: null,
      search: {
        keyword: null,
      },
      source: null,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState?.kodeCabang?.value !== this.state.kodeCabang?.value) {
      this.setState((prev) => ({
        ...prev,
        search: {
          keyword: null,
        },
        keyword: null,
        submittedFilter: null,
        skipNextFetch: true,
      }));
      this.fetchData({}, 5, 1);
    }
    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;
    const skip = this.state.skipNextFetch;
    const filter = this.state.submittedFilter;
    const search = this.state.search;

    if (
      (currPagination.limit !== prevPagination.limit ||
        currPagination.page !== prevPagination.page ||
        search.keyword !== prevState.search.keyword) &&
      !skip
    ) {
      const payload = {
        ...filter,
        ...(search.keyword ? { partName: search.keyword } : {}),
      };
      this.fetchData(payload, currPagination.limit, currPagination.page);
    }
    if (skip) {
      this.setState({ skipNextFetch: false });
    }
  }

  reloadCurrentPage = async () => {
    const { pagination, submittedFilter, search } = this.state;

    const payload = {
      ...submittedFilter,
      ...(search?.keyword ? { partName: search.keyword } : {}),
    };

    await this.fetchData(
      removeNullFields(payload),
      pagination.limit,
      pagination.page,
    );
  };

  getDataTableConfig = () => {
    return getTableConfig({
      onShowDetail: this.handleDetailVisibility,
      onShowStock: this.handleStockVisibility,
      pagination: this.state.pagination,
    });
  };

  fetchData = async (filter = {}, limit, page) => {
    const { setError } = this.props;
    const { kodeCabang } = this.state;

    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getInventoryPartMainPage,
      menuName: "Inventory Part",
      setError: setError,
      args: {
        ...filter,
        kodeCabang: [kodeCabang?.value],
        limit: limit,
        page: page,
      },
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  fetchDataCabang = async () => {
    const { menuAccess, setError } = this.props;

    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      menuName: "Inventory Part",
      setError: setError,
      args: {},
    });
    this.handleTriggerLoading();
    if (res.ok) {
      const filteredData = res.data.data.filter((item) =>
        menuAccess?.map((data) => data.idRefObj).includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          cabangOptions: filteredData?.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang),
          ),
          kodeCabang: mapToObjectDDL(
            filteredData[0].namaDealer,
            filteredData[0].kodeCabang,
          ),
          userAccess: getUserAccess(menuAccess, filteredData[0].kodeCabang),
        }));
      }
    }
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  handleChangeKodeCabang = (val) => {
    this.setState({ kodeCabang: val });
  };

  handleChangePage = (tableState) => {
    this.setState((prev) => ({
      pagination: {
        ...prev.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleChangeRowsPerPage = (tableState) => {
    this.setState((prev) => ({
      pagination: {
        ...prev.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleDetailVisibility = (index, source) => {
    this.setState((prev) => ({
      ...prev,
      detailVisibility: !prev.detailVisibility,
      selectedData: prev?.dataTable?.[index] || null,
      source: source,
    }));
  };

  handleDownloadExcel = async (data) => {
    const { setError } = this.props;
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE")
        .getExcelReportMainPageInventoryPart,
      menuName: "Inventory Part",
      setError: setError,
      args: {
        kodeCabang: data?.map((item) => item.value),
        limit: null,
        page: null,
      },
    });
    this.handleTriggerLoading();
    this.handlePrintVisibility();
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "INVENTORY_PART.xlsx");
    }
  };

  handlePrintVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      printVisible: !prev.printVisible,
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      filterVisible: !prev.filterVisible,
    }));
  };

  handleStockVisibility = (value) => {
    this.setState((prev) => ({
      ...prev,
      stockVisible: !prev.stockVisible,
      selectedData: prev?.dataTable?.[value] || null,
    }));
  };

  handleSubmitFilter = (value) => {
    this.setState((prev) => ({
      ...prev,
      submittedFilter: value,
      pagination: INITIAL_PAGINATION,
      skipNextFetch: true,
      search: {
        keyword: null,
      },
    }));
    const { category, ...rest } = value;
    const payload = { ...rest, ceatgory: category || null };
    this.fetchData(removeNullFields(payload), 5, 1);
    this.handleFilterVisibility();
  };

  handleSearchPartName = () => {
    this.setState((prev) => ({
      ...prev,
      search: {
        keyword: prev.keyword,
      },
    }));
  };

  render() {
    const {
      loading,
      cabangOptions,
      kodeCabang,
      dataTable,
      pagination,
      detailVisibility,
      selectedData,
      printVisible,
      filterVisible,
      submittedFilter,
      stockVisible,
      keyword,
      source,
    } = this.state;
    return (
      <React.Fragment>
        <Container>
          <h3>Inventory Part</h3>
          <FlexView
            className="margin margin-top-10px"
            style={{ justifyContent: "space-between" }}
          >
            <FlexView vAlignContent="center" style={{ gap: "10px" }}>
              <p className="margin margin-bottom-15px">Cabang</p>
              <SimpleDDL
                id="select_options_nama_cabang"
                box="search"
                name="selectedCabang"
                containerclassname="width width-280px"
                placeholder="Nama cabang hak akses"
                options={cabangOptions}
                value={kodeCabang}
                onChange={(value) => this.handleChangeKodeCabang(value)}
              />
              <SimpleButton
                id="btn_search_qr_part"
                text="Cari QR Part"
                className="margin margin-bottom-15px"
                onClick={() =>
                  this.handleDetailVisibility(null, "search-qr-main-page")
                }
              />
            </FlexView>
            <FlexView vAlignContent="center" style={{ gap: "10px" }}>
              <SimpleInput
                id="input_nama_part"
                name="keyword"
                containerclassname="width width-250px"
                placeholder="Nama Part"
                value={keyword}
                onChange={({ target }) =>
                  this.setState({ keyword: target.value })
                }
              />
              <SimpleButton
                id="btn_search_nama_part"
                text="Cari"
                className="margin margin-bottom-15px"
                onClick={this.handleSearchPartName}
              />
              <SimpleButton
                id="btn_filter"
                category="action_button"
                className="btn background-red margin-bottom-15px"
                icon={
                  <span>
                    <i className="fa fa-qrcode" />
                  </span>
                }
                onClick={() => this.handleFilterVisibility()}
              />
            </FlexView>
          </FlexView>
          <SimpleDataTable
            key={`${this.state.pagination.page}-${this.state.pagination.limit}`}
            id="table_inventory_part"
            data={dataTable}
            columns={this.getDataTableConfig()}
            toCount={pagination.totalData}
            rowsPerPage={pagination.limit}
            page={pagination.page - 1}
            options={defaultTableChange(
              this.handleChangePage,
              this.handleChangeRowsPerPage,
            )}
          />
          <FlexView hAlignContent="right" className="margin margin-top-20px">
            <SimpleButton
              id="button_print"
              text="Cetak"
              onClick={() => this.handlePrintVisibility()}
            />
          </FlexView>
        </Container>

        {detailVisibility && (
          <InventoryPartDetail
            {...this.props}
            kodeCabang={kodeCabang}
            source={source}
            selectedData={selectedData}
            visible={detailVisibility}
            onTriggerLoading={this.handleTriggerLoading}
            onClickClose={this.handleDetailVisibility}
          />
        )}
        {printVisible && (
          <InventoryPartDownloadModal
            visible={printVisible}
            cabangOptions={cabangOptions}
            onClickClose={this.handlePrintVisibility}
            onSubmit={this.handleDownloadExcel}
          />
        )}
        {filterVisible && (
          <InventoryPartFilter
            submittedFilter={submittedFilter}
            visible={filterVisible}
            onClickClose={this.handleFilterVisibility}
            onSubmit={this.handleSubmitFilter}
          />
        )}
        {stockVisible && (
          <InventoryPartStock
            {...this.props}
            selectedData={selectedData}
            visible={stockVisible}
            onTriggerLoading={this.handleTriggerLoading}
            onClickClose={this.handleStockVisibility}
          />
        )}
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(InventoryPart);
